import cn from "classnames";
import React, { ReactNode } from "react";

import styles from "./RowGrid.module.scss";

export const enum ROW_GRID_UNIT {
  FR = "fr",
  PERCENT = "%",
}

interface IProps {
  children: ReactNode;
  percents: number[];
  gap?: string;
  className?: string;
  unit?: ROW_GRID_UNIT;
}

const getColumns = ({percents, unit, gap} : { percents: number[], unit: ROW_GRID_UNIT, gap: string }) => {
  if(unit === ROW_GRID_UNIT.PERCENT){
    return percents.map((p) => `calc(${p}${unit} - ${gap})`).join(" ")
  }
  return percents.map((p) => `${p}${unit}`).join(" ");
};

const RowGrid: React.FC<IProps> = ({ children, percents, gap = "1rem", className, unit = ROW_GRID_UNIT.FR }) => {
  return (
    <div className={cn(styles.root, className)} style={{ gap, gridTemplateColumns: getColumns({ percents, unit, gap }) }}>
      {children}
    </div>
  );
};

export default RowGrid;
